const baseSummaryCard = {
    minHeight: 128,
    padding: 16,
    background: '#fff',
    border: '1px solid #e7ebf3',
    borderRadius: 8,
    boxShadow: '0 8px 18px rgba(31, 41, 55, 0.08)',
    overflow: 'hidden'
};

const styles = {
    page: {
        padding: 12,
        background: '#f4f6f9',
        minHeight: '100vh'
    },
    mainCard: {
        borderRadius: 8,
        border: '1px solid #dfe5ef',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.10)'
    },
    header: {
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: 16,
        padding: 18,
        marginBottom: 14,
        borderRadius: 8,
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        color: '#111827',
        flexWrap: 'wrap'
    },
    headerContent: {
        minWidth: 280,
        flex: 1
    },
    headerEyebrow: {
        fontSize: 12,
        fontWeight: 700,
        textTransform: 'uppercase',
        color: '#2563eb',
        marginBottom: 4
    },
    headerTitle: {
        fontSize: 28,
        lineHeight: '34px',
        margin: 0,
        fontWeight: 700
    },
    headerSubtitle: {
        color: '#475569',
        fontSize: 14,
        marginTop: 6
    },
    headerMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexWrap: 'wrap',
        marginTop: 14
    },
    headerDate: {
        fontSize: 13,
        color: '#334155'
    },
    headerActions: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        gap: 8,
        flexWrap: 'wrap',
        minWidth: 260
    },
    summaryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
        gap: 12,
        marginTop: 12,
        marginBottom: 14
    },
    summaryCard: {
        ...baseSummaryCard
    },
    summaryCardPrimary: {
        borderTop: '4px solid #2563eb'
    },
    summaryCardSuccess: {
        borderTop: '4px solid #16a34a'
    },
    summaryCardInfo: {
        borderTop: '4px solid #0891b2'
    },
    summaryCardNeutral: {
        borderTop: '4px solid #64748b'
    },
    summaryCardWarning: {
        borderTop: '4px solid #f59e0b'
    },
    summaryCardDanger: {
        borderTop: '4px solid #dc2626'
    },
    summaryTopline: {
        height: 0
    },
    summaryTitle: {
        fontSize: 12,
        color: '#64748b',
        fontWeight: 700,
        textTransform: 'uppercase',
        marginBottom: 8
    },
    summaryValue: {
        fontSize: 25,
        lineHeight: '31px',
        fontWeight: 700,
        color: '#111827',
        marginBottom: 8
    },
    summaryDescription: {
        fontSize: 12,
        color: '#6b7280',
        lineHeight: '17px'
    },
    palletWeight: {
        minWidth: 170
    },
    palletWeightHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        marginBottom: 6
    },
    palletWeightTrack: {
        height: 6,
        width: '100%',
        background: '#e5e7eb',
        borderRadius: 999,
        overflow: 'hidden'
    },
    palletWeightBar: {
        height: 6,
        borderRadius: 999
    },
    palletWeightBarSuccess: {
        background: '#16a34a'
    },
    palletWeightBarWarning: {
        background: '#f59e0b'
    },
    palletWeightBarDanger: {
        background: '#dc2626'
    },
    reportSearch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: 14,
        marginBottom: 14,
        borderRadius: 8,
        background: '#fff',
        border: '1px solid #e2e8f0',
        flexWrap: 'wrap'
    },
    reportSearchTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: '#111827',
        marginBottom: 3
    },
    reportSearchDescription: {
        fontSize: 12,
        color: '#64748b'
    },
    reportSearchActions: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap'
    },
    dialog: {
        width: '70vw'
    },
    tableHighlightCss: `
        .fio-sem-spi > td {
            background: #fff7ed !important;
            border-top: 1px solid #fed7aa !important;
            border-bottom: 1px solid #fed7aa !important;
        }
    `
};

export default styles;
